import { render, staticRenderFns } from "./VarietiesPage.vue?vue&type=template&id=d6d99524&scoped=true"
import script from "./VarietiesPage.vue?vue&type=script&lang=js"
export * from "./VarietiesPage.vue?vue&type=script&lang=js"
import style0 from "./VarietiesPage.vue?vue&type=style&index=0&id=d6d99524&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d99524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6d99524')) {
      api.createRecord('d6d99524', component.options)
    } else {
      api.reload('d6d99524', component.options)
    }
    module.hot.accept("./VarietiesPage.vue?vue&type=template&id=d6d99524&scoped=true", function () {
      api.rerender('d6d99524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/varieties/VarietiesPage.vue"
export default component.exports